import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ViewStateService } from './view-state.service';

export const navGuard: CanActivateFn = () => {
  const viewState = inject(ViewStateService);

  return !viewState.CurrentViewState.isLoading;
};